import login from "./en/login";

const en = () => {
    const language = {
      ...login
    }
    return language;
  }

  export default en